import { render, staticRenderFns } from "./ReadabilitySettingsPanel.vue?vue&type=template&id=f5ed95d8&scoped=true"
import script from "./ReadabilitySettingsPanel.vue?vue&type=script&lang=ts"
export * from "./ReadabilitySettingsPanel.vue?vue&type=script&lang=ts"
import style0 from "./ReadabilitySettingsPanel.vue?vue&type=style&index=0&id=f5ed95d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed95d8",
  null
  
)

export default component.exports